<template>
  <div class="ausiness-step-box">
    <div class="ausiness-step-content-box">
      <div class="title">合作流程</div>
      <div class="mark">
        我们遵循严格的软件开发生命周期（SDLC），以构建满足您的要求和市场需求的优秀企业网站。
      </div>
      <div class="ausiness-step-content">
        <div
          class="ausiness-item-box"
          v-for="(item, index) in stepList"
          :key="index"
        >
          <div class="ausiness-item hvr-grow">
            <div class="item-icon">
              <img :src="item.icon" alt="" />
            </div>
            <div class="item-title">
              {{ item.title }}
            </div>
            <div class="item-text">{{ item.content }}</div>
          </div>
          <div class="line" v-if="index != stepList.length - 1">
            <img src="@/assets/business/line.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      stepList: [
        {
          icon: require("@/assets/business/icon1.png"),
          title: "递交方案",
          content: "Submit Proposal",
        },
        {
          icon: require("@/assets/business/icon2.png"),
          title: "内部审核",
          content: "Internal audit",
        },
        {
          icon: require("@/assets/business/icon3.png"),
          title: "风格创造",
          content: "Style creation",
        },
        {
          icon: require("@/assets/business/icon4.png"),
          title: "前期沟通",
          content: "Early communication",
        },
        {
          icon: require("@/assets/business/icon5.png"),
          title: "项目探讨",
          content: "Project Discussion",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
